export const DISCIPLINES = [
    "Leadership",
    "Strategy",
    "People Development",
    "Business Structure",
    "Culture",
    "Organizational Performance",
    "Professional Management"
];
